import NotFoundComponent from "PFComponents/not_found/not_found";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import { useParams } from "react-router-dom";

import { CvTemplateEditPage } from "./cv_template_edit_page";
import { useCvTemplateEditPage } from "./use_cv_template_edit_page";

export const CvTemplateEditController = () => {
  const { accountId, templateId } = useParams<{ accountId: string; templateId: string }>();
  const { loaded, cvTemplate, customTypes, errors } = useCvTemplateEditPage({
    id: templateId,
    accountId
  });
  const WrappedEditEmailTemplaPage = usePageWrapper(CvTemplateEditPage);

  return (
    <WrappedEditEmailTemplaPage
      loading={!loaded}
      errors={errors}
      errorComponent={
        <NotFoundComponent
          message={"It looks like the cv template page could not be loaded."}
          buttonMessage={"Please try to come back later"}
          buttonUrl={`/saas_admin/accounts/${accountId}/cv_templates`}
        />
      }
      cvTemplate={cvTemplate.data}
      customTypes={customTypes.data}
      accountId={accountId}
    />
  );
};
